import { memo } from 'react';
import type { MouseEvent } from 'react';

import { ButtonBase } from '@/shared/ui';
import { KeyboardReturn } from '@/shared/ui/icons';

import {
  FACTSHEET_COLUMN_WIDTH,
  LAUNCH_DATE_COLUMN_WIDTH,
  SYMBOL_COLUMN_WIDTH
} from '@/features/catalog/constants';

import { ROW_LEFT_PADDING } from '../../constants';

// Aligns the link under the Title column: row padding + every fixed leading
// column that precedes Title in forwardCurvesColumns (Symbol, Factsheet,
// LaunchDate — Status is hidden by default and contributes no width).
const TITLE_COLUMN_OFFSET = `${ROW_LEFT_PADDING + SYMBOL_COLUMN_WIDTH + FACTSHEET_COLUMN_WIDTH + LAUNCH_DATE_COLUMN_WIDTH}px`;

type ViewInSpotLinkProps = Readonly<{ onClick: () => void }>;

/**
 * Persistent per-row link on every Forward Curves row that opens the Spot view
 * filtered to the same code. Always visible (not hover-only) per the design.
 */
const ViewInSpotLink = ({ onClick }: ViewInSpotLinkProps) => (
  <ButtonBase
    disableRipple
    sx={{
      pl: TITLE_COLUMN_OFFSET,
      py: '4px',
      color: 'gx.highlight',
      fontWeight: 700,
      fontSize: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: 0.5
    }}
    onClick={(e: MouseEvent) => {
      e.stopPropagation();
      onClick();
    }}
  >
    View in Spot
    <KeyboardReturn sx={{ fontSize: 14 }} />
  </ButtonBase>
);

export default memo(ViewInSpotLink);
